// extracted by mini-css-extract-plugin
export default {"header":"Header_header__m0P70","menu":"Header_menu__zxLiT","menu__logo":"Header_menu__logo__0ZnMM"};